/**
 * Lifecycle of a root question; parts follow their root's status. Must match
 * `public.is_question_status_transition_allowed`.
 */
export enum QuestionStatus {
  Draft = 'draft',
  NeedsSolution = 'needs_solution',
  ReadyForEnrichment = 'ready_for_enrichment',
  AwaitingReview = 'awaiting_review',
  Published = 'published',
  Superseded = 'superseded',
  Retired = 'retired',
  Rejected = 'rejected',
}

/** Where a leaf's enrichment stands, as the question list filters it. */
export enum QuestionLeafEnrichmentState {
  /** The leaf carries no current topic, type, directive verb, scale score or relationship. */
  NotEnriched = 'not_enriched',
  /** The leaf's current enrichment is the engine's alone. */
  Engine = 'engine',
  /** A person has overridden the leaf's enrichment at least once. */
  HumanOverride = 'human_override',
  /** The latest enrichment run on the leaf's question failed. */
  RunFailed = 'run_failed',
}

/** The image types a figure in a question may be. Must match the `question-assets` bucket. */
export enum QuestionImageMimeType {
  Png = 'image/png',
  Jpeg = 'image/jpeg',
  Webp = 'image/webp',
}
